import { Theme } from '@lumx/react';

/**
 * Returns the contrasting text color ('dark' or 'light') for a given LumApps theme.
 * Defaults to 'dark' for the light theme and 'light' for all other themes.
 */
export const calculateThemeColor = (theme: string = Theme.light) => (theme !== Theme.light ? 'light' : 'dark');
